import React from "react";
import DOMPurify from "dompurify";
import Table from "../../../../common/components/Table/Table";
import PropTypes from "prop-types";
import _ from "lodash";
import COUNTRIES from "../../../../common/resources/countries.json";
import CollapsibleContainer from "../../../../common/components/CollapsibleContainer";

export default class Overview extends React.Component{

    static propTypes = {
        serviceDetail: PropTypes.object,
        associatedCountries: PropTypes.array,
    }

    state = {
        collapseCountries: false,
    }

    get supportedCountries() {
        const {associatedCountries} = this.props;

        return(
            <div className={"associated-countries-container"}>
                <CollapsibleContainer
                    open={false}
                    title={"Supported Countries"}
                >
                    <div className={"associated-countries-list"}>
                        {associatedCountries.length === 0
                            ? (<span>{"No Supported Countries"}</span>)
                            : associatedCountries.map((country, idx) => {
                                const sourceCountry = _.result(_.find(COUNTRIES, {
                                    value: country
                                }), "label");
                                return (<span key={idx}>{sourceCountry} <br/></span>)
                            })
                        }
                    </div>
                </CollapsibleContainer>
            </div>
        )
    }

    get inputElementsTable() {
        const {serviceDetail} = this.props;
        const inputKeysTableHeaders = [
            <Table.Header key="country">Country</Table.Header>,
            <Table.Header key="tenant">Group Index</Table.Header>,
            <Table.Header key="element">Element</Table.Header>,
        ];
        const inputKeysObject = serviceDetail.input_keys;
        let formattedIpKeys = [];
        let specificCountriesForIpKeys = [];
        let temp = {}
        // initialize the main DS with key as country and empty object as value
        inputKeysObject.forEach(i => {
            if (!specificCountriesForIpKeys.includes(i.country_iso)) {
                specificCountriesForIpKeys.push(i.country_iso);
                temp[i.country_iso] = {}
            }
        });
        // initialize country objects inside main DS with key as input_group_id and value as empty array
        inputKeysObject.forEach(i => {
            if (i.country_iso in temp) {
                temp[i.country_iso][i.input_group_id] = []
            }
        });
        // populate the DS
        inputKeysObject.forEach(i => {
            if (i.input_group_id in temp[i.country_iso]) {
                temp[i.country_iso][i.input_group_id].push(i.label_name)
            }
        });
        // use the DS to create an array of objects which can be rendered into the table.
        for (let [key, value] of Object.entries(temp)) {
            for (let [k, v] of Object.entries(value)) {
                formattedIpKeys.push({
                    id: k,
                    country_iso: key,
                    elements: v.join(", ")
                })
            }
        }

        return(
            <div className={"input-group-container"}>
                <CollapsibleContainer
                    open={true}
                    title={"Required Inputs"}
                >
                    {inputKeysObject
                        ? inputKeysObject.length > 0
                            ? (
                                <div className={"collapsible-table-container"}>
                                    <Table
                                        headers={inputKeysTableHeaders}
                                    >
                                        {formattedIpKeys
                                            ? (formattedIpKeys.map((inputGroup,idx) => {
                                                return (
                                                    <tr key={idx}>
                                                        <td>{inputGroup.country_iso}</td>
                                                        <td>{inputGroup.id}</td>
                                                        <td>{inputGroup.elements}</td>
                                                    </tr>
                                                )}))
                                            : null
                                        }
                                    </Table>
                                </div>
                            )
                            : (
                                <div>
                                    <p>
                                        Not Available.
                                        Please update Input Elements associated
                                        with {serviceDetail.service_detail.service_name}.
                                    </p>
                                </div>
                            )
                        : null}
                </CollapsibleContainer>
            </div>
        )
    }

    render() {
        const {serviceDetail} = this.props;
        const contactInfo = serviceDetail.contact_info;

        return (
            <div className="detail-info">

                <div className={"notes-container"}>
                    <h3>Notes:</h3>
                    {serviceDetail.notes
                        ?  serviceDetail.notes.map((note, idx) => {
                            return (
                                <div key={idx}>
                                    <h4>{note.type}</h4>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.note) }} />
                                </div>
                            )
                        }) : (
                            <div>
                                <p>
                                    Not Available.
                                    Please update Contacts associated
                                    with {serviceDetail.service_detail.service_name}.
                                </p>
                            </div>
                        )
                    }
                </div>

                <div>
                    <h3 style={{marginBottom: "0"}}>Contact(s):</h3>
                    <div className={"contact-info-container"}>
                        {contactInfo
                            ? contactInfo.map((contact, idx) => {
                                return (
                                    <div className={"flex-child"} key={idx}>
                                        <b>{contact.type}</b>
                                        <p>{contact.name}</p>
                                        <p>{contact.email}</p>
                                        <p>{contact.phone_number}</p>
                                    </div>
                                )
                            }) : (
                                <div>
                                    <p>
                                        Not Available.
                                        Please update Contacts associated
                                        with {serviceDetail.service_detail.service_name}.
                                    </p>
                                </div>
                            )
                        }
                    </div>
                </div>

                {this.inputElementsTable}
                {this.supportedCountries}
            </div>
        )
    }
}
